(function() {
    class ImageGalleryV1 extends HTMLElement {
      constructor() {
        super();
        this.images = [];
        this.currentIndex = 0;
      }

      connectedCallback() {
        this.collectImages();
        this.setupGalleryItems();
        
        if (this.dataset.enableLightbox === 'true') {
          this.setupLightbox();
        }
      }

      collectImages() {
        const items = this.querySelectorAll('.ai-gallery-item-adev');
        items.forEach((item) => {
          const img = item.querySelector('.ai-gallery-image-adev');
          if (img) {
            this.images.push({
              src: img.src.replace(/width=\d+/, 'width=2000'),
              alt: img.alt
            });
          }
        });
      }

      setupGalleryItems() {
            const items = this.querySelectorAll('.ai-gallery-item-adev');
            items.forEach((item) => {
                item.addEventListener('click', () => {
                        if (this.dataset.enableLightbox === 'true') {
                            const index = parseInt(item.dataset.index);
                            this.openLightbox(index);
                        }
                });
            });
      }

      setupLightbox() {
        this.lightbox = this.querySelector('.ai-gallery-lightbox-adev');
        this.lightboxImage = this.querySelector('.ai-gallery-lightbox-image-adev');
        this.lightboxCounter = this.querySelector('.ai-gallery-lightbox-counter-adev');
        this.closeBtn = this.querySelector('.ai-gallery-lightbox-close-adev');
        this.prevBtn = this.querySelector('.ai-gallery-lightbox-prev-adev');
        this.nextBtn = this.querySelector('.ai-gallery-lightbox-next-adev');

        this.closeBtn.addEventListener('click', () => this.closeLightbox());
        this.prevBtn.addEventListener('click', () => this.navigateLightbox(-1));
        this.nextBtn.addEventListener('click', () => this.navigateLightbox(1));

        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox) {
            this.closeLightbox();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (!this.lightbox.classList.contains('active')) return;
          
          if (e.key === 'Escape') {
            this.closeLightbox();
          } else if (e.key === 'ArrowLeft') {
            this.navigateLightbox(-1);
          } else if (e.key === 'ArrowRight') {
            this.navigateLightbox(1);
          }
        });
      }

      openLightbox(index) {
        this.currentIndex = index;
        this.updateLightboxImage();
        this.lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
      }

      closeLightbox() {
        this.lightbox.classList.remove('active');
        document.body.style.overflow = '';
      }

      navigateLightbox(direction) {
        this.currentIndex = (this.currentIndex + direction + this.images.length) % this.images.length;
        this.updateLightboxImage();
      }

      updateLightboxImage() {
        const image = this.images[this.currentIndex];
        this.lightboxImage.src = image.src;
        this.lightboxImage.alt = image.alt;
        this.lightboxCounter.textContent = `${this.currentIndex + 1} / ${this.images.length}`;
      }
    }

    customElements.define('image-gallery-v1', ImageGalleryV1);
  })();